import * as v from "@thi.ng/vectors";

export interface Atom {
  id: number;
  text: string;
  color: string;
  home: v.Vec2;
  currentLocation: v.Vec2;
}

export interface Bond {
  atoms: [number, number];
  targetLength: number;
  strength: number;
}

export interface Molecule {
  atoms: Atom[];
  bonds: Bond[];
}

export const nitrous = {
  atoms: [
    {
      id: 0,
      text: "N",
      color: "white",
      home: v.vec2(-6, 0),
      currentLocation: v.vec2(-6, 0),
    },
    {
      id: 1,
      text: "N",
      color: "white",
      home: v.vec2(0, 0),
      currentLocation: v.vec2(0, 0),
    },
    {
      id: 2,
      text: "O",
      color: "#7dd3fc",
      home: v.vec2(6, 0),
      currentLocation: v.vec2(6, 0),
    },
  ],
  bonds: [
    {
      atoms: [0, 1],
      targetLength: 5,
      strength: 1,
    },
    {
      atoms: [1, 2],
      targetLength: 5,
      strength: 1,
    },
  ],
} satisfies Molecule;
